import "unfetch/polyfill";

const handleResponse = function (response) {
  if (response.ok) {
    return response;
  } else {
    throw Error(`${response.status} (${response.statusText})`);
  }
};

export class FetchAdapter {
  static get(url, config = {}) {
    const options = Object.assign(
      {
        method: "GET",
        credentials: "include",
      },
      config
    );

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static post(url, config = {}) {
    const options = Object.assign(config, {
      method: "POST",
      credentials: "include",
    });

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static patch(url, config = {}) {
    const options = Object.assign(config, {
      method: "PATCH",
      credentials: "include",
    });

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static rawFetch(url = "", options = {}) {
    return fetch(url, options);
  }
}
